import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { getAuthToken } from '../automate/apiBase';
import { resetSessionReduxState } from '../redux/sessionReset';
import { clearAuthSession } from './storage';

const ProtectedRoute = ({ children, setIsAuthenticated }) => {
  const token = getAuthToken();

  if (!token) {
    setIsAuthenticated(false);
    return <Navigate to="/login" />;
  }

  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decodedToken.exp < currentTime) {
      clearAuthSession();
      resetSessionReduxState();
      setIsAuthenticated(false);
      return <Navigate to="/login" />;
    }
    // Verify tenant_id is present (required for multitenancy)
    if (!decodedToken.tenant_id) {
      console.error('Token missing tenant_id claim');
      clearAuthSession();
      resetSessionReduxState();
      setIsAuthenticated(false);
      return <Navigate to="/login" />;
    }
  } catch (error) {
    console.error('Invalid token:', error);
    clearAuthSession();
    resetSessionReduxState();
    setIsAuthenticated(false);
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
